import styled from 'styled-components';

export const FormStyled = styled.form` 
  fieldset {
    padding: 0;
    border: none;
  }
`;

export const LegendStyled = styled.legend`
  display: none;
`;
